/**
 * AsyncStorage shim over localStorage — same async API surface the vendored
 * mobile services use (insights cache), so those files vendor verbatim.
 */
function safe<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

const AsyncStorage = {
  async getItem(key: string): Promise<string | null> {
    return safe(() => window.localStorage.getItem(key), null);
  },
  async setItem(key: string, value: string): Promise<void> {
    safe(() => window.localStorage.setItem(key, value), undefined);
  },
  async removeItem(key: string): Promise<void> {
    safe(() => window.localStorage.removeItem(key), undefined);
  },
  async multiRemove(keys: string[]): Promise<void> {
    for (const k of keys) safe(() => window.localStorage.removeItem(k), undefined);
  },
  async getAllKeys(): Promise<string[]> {
    return safe(() => {
      const keys: string[] = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const k = window.localStorage.key(i);
        if (k) keys.push(k);
      }
      return keys;
    }, []);
  },
};

export default AsyncStorage;
